/* eslint-disable no-use-before-define */
import { processRequest } from './managedRequest';
import { PbDispatch, PbGetState } from '../index';
import { PbRequest } from '../pbRequest';

export const ACCOUNTING_AREA_ID_MARKER = '{{ACCOUNTING_AREA_ID}}';

export function processRequestForAccountingArea<T>(
    dispatch: PbDispatch,
    url: string,
    request: RequestInit,
    identifier: PbRequest
): Promise<T> {
    return processRequestForAccountingAreaWithReplacement(
        dispatch,
        `${url}/${ACCOUNTING_AREA_ID_MARKER}`,
        request,
        identifier
    );
}

export function processRequestForAccountingAreaWithReplacement<T>(
    dispatch: PbDispatch,
    url: string,
    request: RequestInit,
    identifier: PbRequest
): Promise<T> {
    return new Promise((resolve, reject) => {
        dispatch(async (intDispatch: PbDispatch, getState: PbGetState) => {
            try {
                const accountingAreaId =
                    getState().partnerManager.selectedPartnerId;
                const urlWithAccountingArea = url.replace(
                    ACCOUNTING_AREA_ID_MARKER,
                    accountingAreaId
                );

                const result = processRequest<T>(
                    intDispatch,
                    urlWithAccountingArea,
                    request,
                    identifier
                );
                resolve(result);
            } catch (e) {
                reject(e);
            }
        });
    });
}
